import { AuthGate } from "@/components/AuthGate";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  return <AuthGate>{children}</AuthGate>;
};

export default ProtectedRoute;
